<script setup lang="ts">
const quantity = defineModel('quantity', { type: Number, required: true });

function increment() {
  quantity.value += 1;
}

function decrement() {
  if (quantity.value >= 1) {
    quantity.value -= 1;
  }
}
</script>

<template>
  <div class="qty">
    <button type="button" class="base-button qty__btn" @click="decrement">
      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="1" viewBox="0 0 12 1">
        <path d="M0 1v0 -1 0h12v0 1 0z" />
      </svg>
    </button>
    <input
      type="number"
      class="qty__control" :value="quantity" readonly
    >
    <button type="button" class="base-button qty__btn" @click="increment">
      <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11">
        <path d="M0 6v0 -1 0h11v0 1 0z" />
        <path d="M5 0v0h1v0 11 0h-1v0z" />
      </svg>
    </button>
  </div>
</template>

<style lang="scss">
.qty {
  display: flex;
  align-items: center;
  max-width: max-content;
  height: 36px;

  &__btn {
    display: flex;
    flex-shrink: 0;
    border: 1px solid var(--border-color);
    align-items: center;
    justify-content: center;
    width: 26px;
    height: 100%;

    &:hover {
      background: var(--primary-color);
      border: 1px solid var(--primary-color);
      transition: 250ms;

      svg path {
        transition: 250ms;
        fill: #fff;
      }
    }
  }

  &__control {
    box-sizing: border-box;
    max-width: 44px;
    height: 100%;
    margin: 0;
    padding-inline: 4px;
    text-align: center;
    border: 1px solid var(--border-color);
    border-right: none;
    border-left: none;
    -moz-appearance: textfield;

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      margin: 0;
      -webkit-appearance: none;
    }
  }

  @media (width <= 768px) {
    display: flex;
    gap: 8px;

    &__btn {
      width: 35px;
      height: 35px;
      background-color: var(--light-primary-color);
      border-radius: 2px;
      border: none;

      svg path {
        fill: #fff;
      }
    }

    &__control {
      width: 100%;
      max-width: 100%;
      border-radius: 2px;
      border-right: 1px solid var(--border-color);
      border-left: 1px solid var(--border-color);
    }
  }
}
</style>
